import { render, staticRenderFns } from "./BrandView.vue?vue&type=template&id=291f4f1c&scoped=true"
import script from "./BrandView.vue?vue&type=script&lang=js"
export * from "./BrandView.vue?vue&type=script&lang=js"
import style0 from "./BrandView.vue?vue&type=style&index=0&id=291f4f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291f4f1c",
  null
  
)

export default component.exports